var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExitCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.035 9.74315L18.5244 0.0281275H17.597C17.4968 -0.00937582 17.388 -0.00937582 17.2879 0.0281275L17.1452 0.183562L9.41679 9.12138L1.66457 0.15763C1.62035 0.103234 1.56507 0.0608473 1.50314 0.0338594C1.44121 0.00687144 1.37435 -0.00396482 1.30789 0.00219542H0.404251L8.89363 9.76905L0.380484 19.5618L0 20.0022H0.903641C1.01215 20.0382 1.12805 20.0382 1.23656 20.0022L1.37923 19.8468L9.51189 10.4426L17.597 19.8468C17.7051 19.9421 17.8385 19.9966 17.9775 20.0022H18.9049L10.035 9.74315Z",
    fill: "#3C3D3C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitCross);
export default __webpack_public_path__ + "static/media/exit-cross.4ff088d2086996002e296b4810f39f2e.svg";
export { ForwardRef as ReactComponent };